import React from 'react';
import {
  Document,
  PDFViewer,
  Page as PDFPage,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { formatDate } from '../../../../../utils'; // Assuming you have a formatDate function

const styles = {
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  contentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5 // Reduced the margin to minimize extra space
  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  columnHeader: {
    width: '20%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '20%',
    padding: 5,
    textAlign: 'center'
  }
};

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const COLORS = ['#f0f0f0', '#e0e0e0'];

const groupByUhid = (data) => {
  const grouped = {};

  // Group data by UHID/IPD No
  data.forEach(item => {
    const key = item.uhid; // Group by UHID
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(item);
  });

  return grouped;
};

export const UhidIPDNoWiseReportPdf = ({ data }) => {
  const groupedData = groupByUhid(data);

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Uhid/IPD No Wise Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            
            {/* Loop through each patient grouped by UHID */}
            {Object.entries(groupedData).map(([uhid, entries], patientIndex) => (
              <View key={patientIndex} style={{ marginBottom: 5 }}>
                {/* Display Patient Info */}
                <Text style={{ fontSize: '8px' }} content={`Uhid: ${uhid}`} />
                <Text style={{ fontSize: '8px' }} content={`Patient: ${entries[0].patient_name}`} />
                <Text style={{ fontSize: '8px' }} content={`Mobile: ${entries[0].mobile}`} />
                <Text style={{ fontSize: '8px' }} content={`Date: ${formatDate(entries[0].date)}`} />
                <Text style={{ fontSize: '8px' }} content={`Gender: ${entries[0].gender}`} />
                <Text style={{ fontSize: '8px' }} content={`Age: ${entries[0].age}`} />
                <Text style={{ fontSize: '8px' }} content={`Guardian: ${entries[0].guardian_name}`} />
                <Text style={{ fontSize: '8px' }} content={`Address: ${entries[0].address}`} />
                <Text style={{ fontSize: '8px' }} content={`Sponsor: ${entries[0].sponsor.name}`} />
                <Text style={{ fontSize: '8px' }} content={`Payment Mode: ${entries[0].pay_mode}`} />
                <Text style={{ fontSize: '8px' }} content={`Total Amount: ${entries[0].total_amt}`} />
                <Text style={{ fontSize: '8px' }} content={`Remarks: ${entries[0].remarks}`} />

                {/* Loop through the service items for the current patient */}
                <View style={styles.table}>
                  <View style={styles.row}>
                    <Text style={styles.columnHeader} content="Sr" />
                    <Text style={styles.columnHeader} content="Service" />
                    <Text style={styles.columnHeader} content="Quantity" />
                    <Text style={styles.columnHeader} content="Rate" />
                    <Text style={styles.columnHeader} content="Amount" />
                    <Text style={styles.columnHeader} content="Sample Collected" />
                  </View>

                  {/* Loop through each entry and display their service items */}
                  {entries.flatMap(entry => entry.service_items).map((item, index) => (
                    <View
                      key={index}
                      style={{
                        ...styles.row,
                        backgroundColor: COLORS[index % COLORS.length]
                      }}
                    >
                      <Text style={styles.columnContent} content={index + 1} />
                      <Text style={styles.columnContent} content={ item.service?.test_name} />
                      <Text style={styles.columnContent} content={item.quantity || 0} />
                      <Text style={styles.columnContent} content={item.rate || 0} />
                      <Text style={styles.columnContent} content={item.amount || 0} />
                      <Text style={styles.columnContent} content={item.sample_collected ? 'Yes' : 'No'} />
                    </View>
                  ))}
                </View>
              </View>
            ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default UhidIPDNoWiseReportPdf;
